<template>
  <div>
    <div class="flex items-center justify-center"><p>{{ $t("my_payments") }}</p></div>
    <div v-if="result && result.length > 0" ref="scrollContainer" class="mt-12 br16 altBackground p-4 overflow-y-auto fix-height" @scroll="onScroll">
      <ul>
        <li v-for="pay in result" :key="pay.sale?.id">
          <div class="component justify-between">
            <div class="component-info flex justify-center items-center">
              <h3>{{ getBeautifyDate(pay.date) }}</h3>
            </div>
            <div class="component-info flex justify-center items-center">
              <h3>{{ capitalizeFirstLetter(pay.sale?.tenant?.name ?? '') }}</h3>
            </div>
            <div class="component-info flex justify-center items-center">
              <h3>
                {{  pay.amountData?.grossAmountStr }}
              </h3>
            </div>
          </div>
          <div class="linearSpace"></div>
        </li>
      </ul>
    </div>
    <div v-else class="flex items-center justify-center mt-20 br16 altBackground p-4"><p>{{ $t("dont_have_any_pay") }}</p></div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { beautifyDate } from "@/helpers/dateHelper";
import PaymentHelper from "@/helpers/paymentHelper";
import { Payment } from "models";
import store from '@/store';
import { capitalizeFirstLetter } from "@/helpers/dateHelper";
import { useRefreshWatcher } from "@/helpers/dataHelper";

export default defineComponent({
  name: "MyPays",
  data() {
    return {
      start: 0,
      size: 50,
      result: [] as Payment[],
      newItems: [] as Payment[],
      loading: false,
    };
  },
  async mounted() {
    useRefreshWatcher(() => { this.loadData(this.start, this.size); });// This function will execute when the 'isRefreshed' state changes. It is passed this way because it is passed by reference.
    this.loadData(this.start, this.size);
  },
  
  methods: {
    capitalizeFirstLetter,
    async loadData(start: number, size: number) {
      if (this.loading) return;
      this.loading = true;
      store.commit("setLoading", true);
      this.newItems = await PaymentHelper.findPaymentByCustomer(start, size);
      if(this.newItems){
        this.result = this.result.concat(this.newItems);
      }
      store.commit("setLoading", false);
      this.start += 1;//prepare next page load
      this.loading = false;
    },
    getBeautifyDate(date: any) {
      return beautifyDate(date, true, true);
    },
    onScroll() {
      const container = this.$refs.scrollContainer as HTMLElement;
      if (this.loading || !container || !this.newItems) return;
      const nearBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 20;
      if (nearBottom) {
        this.loadData(this.start, this.size);
      }
    },
  },
});
</script>

<style scoped>
.fix-height {
  max-height: calc(100vh - 250px);
}
.linearSpace {
  background: linear-gradient(
    270deg,
    #023b70 3.65%,
    #406297 19.27%,
    #4668a0 83.33%,
    #033768 100%
  );
  height: 1px;
}
.component {
  display: flex;
  margin-bottom: 10px;
  margin-top: 10px;
}
.component-info {
  width: 33%;
  min-height: 80px;
}
</style>

